<template>
	<section class="m-card" v-if="data.length > 0">
		<h2 class="m-card-title">老師媒體</h2>
		<ul>
			<li v-for="item in data" :key="item.id" @click="goLink(item.jump_url)">
				<van-image class="icon" :src="item.cover_cc || item.cover" alt="" />
				<div class="title">{{ item.name }}</div>
			</li>
		</ul>
	</section>
</template>

<script setup>
import { goLink } from "~/utils/common";

const props = defineProps({
	data: {
		type: Object,
		default: () => ({}),
	},
});
</script>

<style lang="scss" scoped>
.m-card {
	margin-top: 64px;
	padding: 0 32px;
	font-family: PingFang SC;

	.m-card-title {
		font-weight: 600;
		font-size: 40px;
		color: #333333;
		line-height: 60px;
	}

	.title,
	.desc {
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	ul {
		display: flex;
		margin-top: 32px;
		border-radius: 16px;
		background-color: #ffffff;
		overflow: hidden;

		li {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			width: 138px;
			height: 152px;
			background-color: #ffffff;
			cursor: pointer;

			&:last-child {
				margin-right: 0;
			}

			.icon {
				width: 76px;
				height: 76px;
			}

			.title {
				margin-top: 12px;
				font-weight: 500;
				font-size: 22px;
				color: #2b2f36;
				line-height: 26px;
				text-align: center;
			}
		}
	}
}
</style>
